import type { Quote } from "./types";
import { createQuoteStory } from "./types";

export const musaTaha25: Quote = {
  id: "musa-taha-25",
  name: "Doa Sebelum Tugas Berat",
  emoji: "🔥",
  category: "Doa & Dzikir",
  description:
    "Nabi Musa berdoa sebelum menghadapi Firaun: **\"Lapangkan dadaku, mudahkan urusanku.\"** Doa singkat untuk setiap tugas berat.",
  detail:
    "Ketika Allah memerintahkan Musa untuk menghadap Firaun — penguasa paling kejam di zamannya — Musa tidak langsung berangkat. Dia **berdoa dulu**. Minta dada dilapangkan, urusan dimudahkan, dan lidah dilancarkan. Ini mengajarkan bahwa persiapan terbaik sebelum menghadapi hal berat adalah **meminta pertolongan Allah**.",
  tldr: "Doa Musa sebelum menghadapi Firaun — cocok untuk setiap tantangan berat.",
  story: createQuoteStory("Doa Sebelum Tugas Berat", "🔥", [
    { hook: {
      title: "Besok ada sesuatu yang bikin deg-degan?",
      body: "Presentasi, ujian, percakapan sulit, wawancara kerja — apapun itu, ada doa nabi yang **pas banget** untuk momen ini.",
    } },
    { source: {
      arabic: "رَبِّ اشْرَحْ لِي صَدْرِي وَيَسِّرْ لِي أَمْرِي وَاحْلُلْ عُقْدَةً مِّن لِّسَانِي يَفْقَهُوا قَوْلِي",
      body: "Ya Tuhanku, **lapangkan dadaku**, **mudahkan urusanku**, dan lepaskan kekakuan dari lidahku agar mereka **memahami perkataanku**.",
      title: "QS. Taha: 25-28",
    } },
    { reveal: {
      body: "Musa diminta menghadap **Firaun** — penguasa paling kejam di zamannya. Respons pertamanya bukan panik, bukan menolak. Tapi **berdoa**. Persiapan terbaik sebelum tugas berat adalah bicara dengan Allah dulu.",
    } },
    { insight: {
      title: "Tiga permintaan, satu pola",
      body: "**Lapangkan dadaku** — minta ketenangan hati, bukan hilangkan rasa takut.\n**Mudahkan urusanku** — minta pertolongan proses, bukan jaminan hasil.\n**Lancarkan lidahku** — minta kemampuan menyampaikan, bukan kata-kata sempurna.\n\nMusa gak minta tugas dibatalkan. Dia minta **kekuatan untuk menjalaninya.**",
    } },
    { engagement: {
      title: "Apapun yang kamu hadapi besok...",
      body: "Baca doa ini malam ini. Bukan karena semuanya akan jadi mudah — tapi karena **kamu gak akan menghadapinya sendirian.**",
    } },
  ]),
  related: ["zakaria-anbiya-89", "yunus-anbiya-87"],
};
